import React from "react";
import "./Ticker.css";

interface TickerLogo {
  src: string;
  alt: string;
  href?: string;
}

interface TickerProps {
  logos: TickerLogo[];
  speed?: number; // seconds for one complete cycle
  direction?: "left" | "right";
  title?: string;
}

function LogoGroup({
  logos,
  ariaHidden,
}: {
  logos: TickerLogo[];
  ariaHidden?: boolean;
}) {
  return (
    <div className="ticker-group" aria-hidden={ariaHidden || undefined}>
      {logos.map((logo, index) => {
        const img = (
          <img
            src={logo.src}
            alt={ariaHidden ? "" : logo.alt}
            className="sponsor-logo"
            loading="eager"
            decoding="async"
            draggable={false}
          />
        );

        // Duplicate loop group is decorative — skip links so they aren't double-focusable
        if (ariaHidden || !logo.href) {
          return (
            <span
              key={`${ariaHidden ? "b" : "a"}-${logo.alt}-${index}`}
              className="ticker-logo-item"
            >
              {img}
            </span>
          );
        }

        return (
          <a
            key={`a-${logo.alt}-${index}`}
            href={logo.href}
            target="_blank"
            rel="noopener noreferrer"
            className="ticker-logo-link"
            aria-label={`${logo.alt} (opens in new tab)`}
          >
            {img}
          </a>
        );
      })}
    </div>
  );
}

/** Two identical groups, animate -50% for a seamless loop. */
const Ticker: React.FC<TickerProps> = ({
  logos,
  speed = 30,
  direction = "left",
  title,
}) => {
  return (
    <div className="ticker-section">
      <div className="ticker-container">
        {title && <h2 className="ticker-title">{title}</h2>}
        <div className={`ticker-row ticker-${direction}`}>
          <div
            className="ticker-track"
            style={{ ["--ticker-duration" as string]: `${speed}s` }}
          >
            <LogoGroup logos={logos} />
            <LogoGroup logos={logos} ariaHidden />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ticker;
